import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <div className="not-found-container">
        <div className="not-found-illustration">
          <img 
            src="https://cshmhfxwounurylautnc.supabase.co/storage/v1/object/public/scanmaster-logo/Parrot%20SEO%20404%20page%20element.png"
            alt="404 illustration"
            className="not-found-image"
          />
        </div>
        <div className="not-found-content">
          <h1 className="not-found-title">Page Not Found</h1>
          <p className="not-found-description">
            Oops! The page you're looking for doesn't exist or has been moved.
          </p>
          <div className="not-found-actions">
            <button
              className="not-found-button primary"
              onClick={() => navigate('/dashboard')}
            >
              Go to Dashboard
            </button>
            <button
              className="not-found-button secondary"
              onClick={() => navigate(-1)}
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
